import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTotalFactura } from "../../../hook/useTotalFactura";
import { puedeEmitir, motivoNoEmitir, tienePlanAplicado } from "../../../utils/facturaCrear";
import "../../../styles/FacturaCrear.css";

/* ============================================================================
   CREAR FACTURA · barra superior

   Sustituye a la fila de migas de pan con cuatro botones morados idénticos, en
   la que la acción principal no se distinguía de las otras tres.

   El TOTAL vive aquí además de en el resumen del pie. En la disposición
   apilada el resumen queda al final, así que con diez procedimientos se sale
   de pantalla justo cuando el usuario está agregando ítems y quiere ver cómo
   sube el total.

   Este botón y el del resumen comparten la MISMA condición (`puedeEmitir`) y
   abren el MISMO modal: no hay dos caminos de emisión, hay uno pintado dos
   veces. Y cuando está apagado, dice por qué -- hoy simplemente no responde.

   NO cambia ninguna regla: la condición sale tal cual de TotalesFactura.js.
   ========================================================================== */

export default function BarraFactura({ onEmitir }) {
    const { total } = useTotalFactura();
    const procedimientos = useSelector((state) => state.facturaredux.procedimientos) || [];
    const tienePlan = tienePlanAplicado(procedimientos);

    const habilitado = puedeEmitir({ total, tienePlan });
    const motivo = motivoNoEmitir({ total, tienePlan, procedimientos });

    return (
        <div className="fcrear__barra">
            <Link to="/factura-listar" className="fcrear__volver">‹ Facturas</Link>

            <div className="fcrear__barra-titulo">
                <span className="fcrear__barra-h1">Nueva factura</span>
                <span className="fcrear__chip">Sin emitir</span>
            </div>

            <div className="fcrear__barra-fin">
                <div className="fcrear__barra-total">
                    <span className="fcrear__barra-total-lab">Total</span>
                    <span className="fcrear__barra-total-val">${total.toFixed(2)}</span>
                </div>

                <button
                    type="button"
                    className="fcrear__btn fcrear__btn--primario"
                    disabled={!habilitado}
                    onClick={onEmitir}
                    title={motivo || "Emitir factura"}
                >
                    Emitir factura
                </button>
            </div>

            {motivo && <p className="fcrear__barra-motivo">{motivo}</p>}
        </div>
    );
}
